<template>		
	<div>		
		<div class="block sm:hidden mx-4">
			<div v-for="pedido in ordenes" v-bind:key="pedido.id" :class="isSelected(pedido) ? 'border-primary' : 'border-gray-200'" class="border rounded mb-4 p-2 bg-white">
				<label v-if="selectionMode" :class="canSelect(pedido) ? 'cursor-pointer' : 'opacity-40'" class="flex items-center gap-2 pb-2">
					<input
						type="checkbox"
						class="w-5 h-5"
						:checked="isSelected(pedido)"
						:disabled="!canSelect(pedido)"
						@change="toggleSelection(pedido)"
					>
					<span>Seleccionar orden {{ pedido.id }}</span>
				</label>

				<div v-if="fields.estado !== false" class="flex w-full gap-2">
					<router-link v-if="fields.estado !== false" :to=' getLinks(pedido).pedido ' class="w-full">
						<div :class="[getStatus(pedido).style]" class="rounded-full text-center py-1 px-2">
							<p class="whitespace-nowrap">{{ getStatus(pedido).text }}</p>
						</div>
					</router-link>
				</div>
				<div v-if="fields.recoleccion && getCurrentOrderCollection(pedido)" class="mt-2">
					<router-link :to="getCollectionLink(pedido)" class="underline font-medium">
						{{ getCurrentOrderCollection(pedido).id }}
					</router-link>
				</div>
				<div class="flex flex-row pt-2 overflow-x-scroll w-full space-x-2" v-if="!pedido.cancelado">
					<div v-if="fields.aprobar" class="basis-3/12 w-full">
						<label class="block text-gray-400 text-sm font mb-1" for="nombre">
							Aprobación
						</label>
						<div  :class="[pedido.require_aprobacion ? ( pedido.aprobado ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center py-1 px-2">
							<p class="whitespace-nowrap">{{ pedido.require_aprobacion ? ( pedido.aprobado ? "Aprobado" : "Por abrobar") : "No requiere"}}</p>
						</div>
					</div>
					<div v-if="fields.surtir" class="basis-3/12 w-full">
						<label class="block text-gray-400 text-sm font mb-1" for="nombre">
							Surtido
						</label>
						<surtir :pedido="pedido" :user="props.user"></surtir>
					</div>
					<div v-if="fields.facturar" class="basis-3/12 w-full">
						<label class="block text-gray-400 text-sm font mb-1" for="nombre">
							Factura
						</label>
						<div :class="[pedido.require_factura ? ( pedido.pedido_factura.length > 0 ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center py-1 px-2">
							<p class="whitespace-nowrap">{{ pedido.require_factura ? ( pedido.pedido_factura.length > 0 ? "Facturado" : "Por subir") : "No requiere"}}</p>
						</div>
					</div>
					<div v-if="fields.entregar" class="basis-3/12 w-full">
						<label class="block text-gray-400 text-sm font mb-1" for="nombre">
							Entrega
						</label>
						<entregar :pedido="pedido"></entregar>						
					</div>
					<div v-if="fields.pago && pedido.proveedor.payments" class="basis-3/12 w-full">
						<label class="block text-gray-400 text-sm font mb-1" for="nombre">
							Pago
						</label>
						<div :class="[getOrderPaymentStatus(pedido).style]" class="rounded-full text-center py-1 px-2">
							<p class="whitespace-nowrap">{{ getOrderPaymentStatus(pedido).label }}</p>
						</div>
					</div>
				</div>
				<div class="w-full mt-2">
					<div class="flex flex-row  justify-between">											
						<router-link :to=' getLinks(pedido).pedido ' class="underline cursor-pointer">
							{{pedido.id}}
						</router-link>
						<div v-if="!fields.cliente && !fields.proveedor" class="whitespace-nowrap flex-row flex">
							{{(user == 'admin') ? formatTime(pedido) : (pedido.created_at ? (new Date(pedido.created_at)).toLocaleDateString("en-GB", { timeZone: 'America/Mexico_City' }) : "") }}
							<div @click="togglePedido(pedido)" class="cursor-pointer flex-none">
								<div v-if="!showPedido[pedido.id]">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
										<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
									</svg>
								</div>
								<div class="h-6 w-6" v-if="showPedido[pedido.id]">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
										<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
									</svg>
								</div>
							</div>
						</div>							
					</div>
					
					<div class="flex flex-row justify-between">	
						<router-link v-if="fields.cliente" :to=' getLinks(pedido).cliente ' class="underline cursor-pointer truncate w-full">
							{{pedido.cliente.nombre}} 
						</router-link>		
						<div v-if="fields.proveedor" class="truncate w-full">
							{{pedido.proveedor ? pedido.proveedor.nombre : "No tiene proveedor"}} 
						</div>

						<div v-if="fields.cliente || fields.proveedor" @click="togglePedido(pedido)" class="cursor-pointer flex-none">
							<div v-if="!showPedido[pedido.id]">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
									<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
								</svg>
							</div>
							<div class="h-6 w-6" v-if="showPedido[pedido.id]">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
									<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
								</svg>
							</div>
						</div>
					</div>
				</div>				

				<div v-if="showPedido[pedido.id] && pedido.instrucciones" class="w-full mt-2">
					<label class="block text-gray-400 text-sm font" for="nombre">
						Instrucciones
					</label>
					<div>
						<p class="">{{ pedido.instrucciones }}</p>
					</div>
				</div>

				<div v-if="showPedido[pedido.id]" class="overflow-x-hidden">
					<div class="w-full pt-0 pt-2 overflow-x-scroll">						
						<div class="rounded">
							<table class="text-sm text-left bg-background-light w-full">
								<thead class="text-s border-b border-b-gray-300 align-top">
									<th scope="col" class="py-3 px-4 w-1/4">
										Producto
									</th>
									<th scope="col" class="py-3 px-4 w-1/4">
										Cantidad 
									</th>								
									<th v-if="user !='admin' " scope="col" class="py-3 px-4 w-1/4">
										Precio
									</th>
									<th v-if="user !='admin' " scope="col" class="py-3 px-4 w-1/4">
										Total
									</th>
								</thead>
								<tbody>
									<tr class="text-s " v-for="line_item in pedido.line_items" v-bind:key="line_item.id">
										<td class="py-3 px-4 whitespace-nowrap">
											{{line_item.producto.nombre}}
										</td>
										<td class="py-3 px-4">
											{{line_item.cantidad}}
										</td>									
										<td v-if="user !='admin' " class="py-3 px-4">
											${{line_item.precio}}
										</td>
										<td v-if="user !='admin' " class="py-3 px-4">
											${{line_item.precio * line_item.cantidad}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>	

					<div v-if="!hideActions && showPedido[pedido.id] && !orderActionsDisabled(pedido) && (user == 'admin' || pedido.proveedor.standalone) && !pedido.cancelado">
						<div class="pt-2">
							<router-link :to="`/admin/orden/${pedido.id}/remision`">
								<button  class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4">
									Ver remisión
								</button>				
							</router-link>				
						</div>
					</div>

					<div v-if="!hideActions && showPedido[pedido.id] && canViewInvoices(pedido) && pedido.require_factura && pedido.pedido_factura.length > 0">
						<div class="pt-2">
							<button  class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="openFacturas(pedido)">
								Ver facturas
							</button>								
						</div>
					</div>

					<div v-if="!hideActions && showPedido[pedido.id] && user == 'admin' && requiereSurtir(pedido)">
						<div class="pt-2">
							<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="surtirPedido(pedido)">
								Surtir
							</button>
						</div>
					</div>

					<div v-if="showPedido[pedido.id] && user == 'admin' && canBeCancelled(pedido)">
						<div class="pt-2">
							<button class="w-full bg-red hover:bg-red-dark rounded text-white font-bold py-2 px-4" @click="cancelarPedido(pedido)">
								Cancelar
							</button>
						</div>
					</div>

					<div v-if="!hideActions && showPedido[pedido.id] && pedido.require_entrega && ((user == 'admin' && (pedido.proveedor.standalone || isCollectionReceived(pedido) || pedido.surtido)) || (user == 'proveedor' && pedido.proveedor.standalone))" class=" pt-2">
						<div v-if="pedido.envios.length > 0" class="w-full overflow-x-scroll">
							<div class="rounded bg-background-light">
								<table class="w-full text-sm text-left ">
									<thead class="text-s border-b border-b-gray-300 align-top">
										<th scope="col" class="py-3 px-4">
											Envio
										</th>
										<th scope="col" class="py-3 px-4">
											Tipo
										</th>
										<th scope="col" class="py-3 px-4">
											Estatus 
										</th>
										<th scope="col" class="py-3 px-4">
											Evidencia 
										</th>
										<th scope="col" class="py-3 px-4">

										</th>
									</thead>
									<tbody v-for="envio in pedido.envios" v-bind:key="envio.id">
										<tr class="text-s">
											<td class="py-2 px-4 whitespace-nowrap">
												{{envio.id}}
											</td>
											<td class="py-2 px-4">
												{{utils.upperCase(envio.type)}}
											</td>													
											<td class="py-2 px-4">												
												<div :class="[getStatusEnvio(envio).style]" class="rounded-full text-center py-1 px-2 mr-2">
													<p class="whitespace-nowrap">{{utils.upperCase(envio.status)}}</p>
												</div>
											</td>
											<td class="py-2 px-4">																							
												<div v-if=" envio.status != 'cancelado' " :class="[( (envio.evidencia && envio.evidencia.length > 0) ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500')]" class="rounded-full text-center py-1 px-2">
													<p class="whitespace-nowrap">{{ (envio.evidencia && envio.evidencia.length > 0) ? "Subido" : "Por subir"}}</p>
												</div>
											</td>
										<td v-if="canManageDelivery(pedido)" @click="editEnvio[envio.id] == null ? editEnvio[envio.id] = true : editEnvio[envio.id] = !editEnvio[envio.id]" class="cursor-pointer pr-2">
												<div v-if="!editEnvio[envio.id]">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
														<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
													</svg>
												</div>
												<div class="h-6 w-6" v-if="editEnvio[envio.id]">
													<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
														<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
													</svg>
												</div>
											</td>													
										</tr>	

									<tr v-if="editEnvio[envio.id] && canManageDelivery(pedido)">
											<td colspan="99" class="">
												<div class="px-2 pb-2 cursor-pointer">
													<div class="w-full text-center rounded bg-primary hover:bg-primary-dark text-white font-bold">
														<label class="inline-block w-full py-2 px-4" :for="envio.id">Subir evidencia</label>
														<input
														class="hidden"
														type="file"
														:id="envio.id"
														accept="*az"
														@change="subirEvidencia(envio, $event)"
														/>
													</div>
												</div>

												<div class="flex justify-between px-2 pb-2">														
													<select class="w-2/3 border border-gray-300 focus:border-gray-500 border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline whitespace-nowrap" v-if="editEnvio[envio.id]" v-model="envio.newStatus">
														<option selected disabled :value="undefined">Escoger un estatus</option>
														<option value="pendiente">Pendiente</option>			
														<option value="exitoso">Exitoso</option>			
														<option value="fallido">Fallido</option>			
												<option v-if="user == 'admin'" value="cancelado">Cancelado</option>
													</select>

													<div class="w-1/3 text-left pl-4 flex-none">
														<button class="w-full rounded bg-primary hover:bg-primary-dark text-white font-bold p-2 px-4"  @click="updateEnvio(envio, {status: envio.newStatus});envio.newStatus = undefined">
															Actualizar 
														</button>
													</div>
												</div>										
											<div v-if="user == 'admin' && isBillableDelivery(pedido, envio)" class="flex flex-row w-full px-2 pb-2">
													<div class="w-2/3 flex flex-row">
														<input class="w-1/2 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="nombre" type="number" placeholder="0" min="0" v-model="envio.cargo_extra">
														<select class="w-1/2 border border-gray-300 focus:border-gray-500 border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline whitespace-nowrap ml-4" v-if="editEnvio[envio.id]" v-model="envio.cargo_extra_type">
															<option selected disabled :value="null">Escoger un tipo</option>
															<option value="express">Express</option>			
															<option value="materiales">Materiales</option>
															<option value="peso">Peso</option>	
															<option value="peso_express">Peso y Express</option>	
															<!-- <option value="">Quitar</option>															 -->
														</select>
													</div>
													<div class="w-1/3 pl-4">
														<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="agregarCargoExtra(envio)">
															Agregar cargo
														</button>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						
						<div v-if="canCreateEnvio(pedido)" class="pt-2">
							<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="crearEnvio(pedido)">
								Crear envio
							</button>
						</div>					
					</div>		
				</div> 
			</div>
		</div>
		<div class="hidden sm:block mx-4 border border-gray-200 rounded bg-white">
			<div class="overflow-scroll">
				<table class="w-full text-sm text-left ">
					<thead class="text-s border-b border-b-gray-200">
						<tr>
							<th v-if="selectionMode" scope="col" class="w-5 py-3 pl-4">
								<span class="sr-only">Seleccionar</span>
							</th>
							<th v-if="fields.estado !== false" scope="col" class="py-3 pr-4 pl-4">
								Estado
							</th>
							<th scope="col" class="py-3 pr-4" :class="fields.estado === false ? 'pl-4' : ''">
								Orden
							</th>
							<th v-if="fields.recoleccion" scope="col" class="py-3 pr-4">
								Recolección
							</th>
							<th scope="col" class="py-3 pr-4">
								Fecha
							</th>
							<th v-if="fields.cliente" scope="col" class="py-3 pr-4">
								Cliente
							</th>	
							<th v-if="fields.proveedor" scope="col" class="py-3 pr-4">
								Proveedor
							</th>				
							<th scope="col" class="py-3 pr-4" v-if="fields.aprobar">
								Aprobación
							</th>								
							<th scope="col" class="py-3 pr-4" v-if="fields.surtir">
								Surtido
							</th>

							<th scope="col" class="py-3 pr-4" v-if="fields.facturar">
								Factura
							</th>
							<th scope="col" class="py-3 pr-4" v-if="fields.entregar">
								Entrega
							</th>
							<th scope="col" class="py-3 pr-4" v-if="fields.evidencia">
								Evidencia
							</th>	
							<th scope="col" class="py-3 pr-4" v-if="fields.pago">
								Pago
							</th>					
							<th class="py-3 pr-2">
							</th>				
						</tr>
					</thead>
					<tbody v-for="pedido in ordenes" v-bind:key="pedido.id">
						<tr :class="isSelected(pedido) ? 'bg-green-50' : ''" class="text-s border-t">
							<td v-if="selectionMode" class="w-5 py-3 pl-4">
								<input
									type="checkbox"
									class="w-5 h-5"
									:aria-label="`Seleccionar orden ${pedido.id}`"
									:checked="isSelected(pedido)"
									:disabled="!canSelect(pedido)"
									@change="toggleSelection(pedido)"
								>
							</td>
							<td v-if="fields.estado !== false" class="pr-4 pl-4">
								<div :class="[getStatus(pedido).style]" class="rounded-full text-center w-48 py-1 px-2">
									<p class="whitespace-nowrap">{{ getStatus(pedido).text }}</p>
								</div>
							</td>

							<td scope="row" class="py-4 pr-4 font-medium whitespace-nowrap underline cursor-pointer" :class="fields.estado === false ? 'pl-4' : ''">
								<router-link :to=' getLinks(pedido).pedido '>
									{{pedido.id}}
								</router-link>
							</td>
							<td v-if="fields.recoleccion" class="py-3 pr-4 whitespace-nowrap">
								<router-link v-if="getCurrentOrderCollection(pedido)" :to="getCollectionLink(pedido)" class="underline font-medium">
									{{ getCurrentOrderCollection(pedido).id }}
								</router-link>
								<span v-else class="text-gray-400">—</span>
							</td>
							<td class="py-3 pr-4 whitespace-nowrap">
								{{(user == 'admin') ? formatTime(pedido) : (pedido.created_at ? (new Date(pedido.created_at)).toLocaleDateString("en-GB", { timeZone: 'America/Mexico_City' }) : "") }}
							</td>
							<td v-if="fields.cliente" class="py-3 pr-6 whitespace-nowrap underline cursor-pointer">
								<router-link :to=' getLinks(pedido).cliente '>
									{{pedido.cliente.nombre}} 
								</router-link>
							</td>
							<td v-if="fields.proveedor" class="py-3 pr-6 whitespace-nowrap">{{pedido.proveedor ? pedido.proveedor.nombre : "No tiene proveedor"}} 
							</td>
							<td v-if="fields.aprobar" class="pr-4">
								<div v-if="!pedido.cancelado" :class="[pedido.require_aprobacion ? ( pedido.aprobado ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center w-auto py-1 px-2">
									<p class="whitespace-nowrap">{{ pedido.require_aprobacion ? ( pedido.aprobado ? "Aprobado" : "Por abrobar") : "No requiere"}}</p>
								</div>
							</td>						
							<td v-if="fields.surtir" class="pr-4">							
								<surtir :pedido="pedido" :user="props.user"></surtir>
							</td>
							<td v-if="fields.facturar" class="pr-4">						
								<div v-if="!pedido.cancelado" :class="[pedido.require_factura ? ( pedido.pedido_factura.length > 0 ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center w-auto py-1 px-2">
									<p class="whitespace-nowrap">{{ pedido.require_factura ? ( pedido.pedido_factura.length > 0 ? "Facturado" : "Por subir") : "No requiere"}}</p>
								</div>

							</td>
							<td v-if="fields.entregar" class="pr-4">
								<entregar :pedido="pedido"></entregar>						
							</td>
							
							<td v-if="fields.evidencia" class="pr-4">
								<div v-if="!pedido.cancelado" :class="[pedido.require_entrega ? ( hasPendingEvidence(pedido) ? 'border border-yellow-500 text-yellow-500' : 'border border-primary text-primary') : 'border text-gray-300 border-gray-300']" class="rounded-full text-center py-1 px-2">
									<p class="whitespace-nowrap">{{ pedido.require_entrega ? ( hasPendingEvidence(pedido) ? "Pendiente" : "Evidencia") : "No requiere"}}</p>
								</div>
							</td>

							<td v-if="fields.pago" class="pr-4">
								<div v-if="pedido.proveedor.payments && !pedido.cancelado">
									<div :class="[getOrderPaymentStatus(pedido).style]" class="rounded-full text-center py-1 px-2">
										<p class="whitespace-nowrap">{{ getOrderPaymentStatus(pedido).label }}</p>
									</div>
								</div>
							</td>

							<td @click="togglePedido(pedido)" class="cursor-pointer pr-4">
								<div class="w-full flex flex-row-reverse">
									<div v-if="!showPedido[pedido.id]">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
											<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
										</svg>
									</div>
									<div class="h-6 w-6" v-if="showPedido[pedido.id]">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
											<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
										</svg>
									</div>
								</div>
							</td>
						</tr>   

						<tr v-if="showPedido[pedido.id]">
							<td colspan="99" class="pb-4">
								<div class="mb-2" v-if="pedido.instrucciones">
									<label class="block text-gray-400 text-sm font px-4" >
										Instrucciones
									</label>
									<div>
										<p class="px-4 mb-2">{{ pedido.instrucciones }}</p>
									</div>
								</div>

								<div class="w-full px-4">
									<div class="rounded bg-background-light">
										<table class="w-full text-sm text-left ">
											<thead class="text-s border-b border-b-gray-300 align-top">
												<th scope="col" class="py-3 px-6 w-1/4">
													Producto
												</th>
												<th scope="col" class="py-3 px-6 w-1/4">
													Cantidad 
												</th>
												<th v-if="user !='admin' " scope="col" class="py-3 px-6 w-1/4">
													Precio
												</th>
												<th v-if="user !='admin' " scope="col" class="py-3 px-6 w-1/4">
													Total
												</th>
											</thead>
											<tbody  v-for="line_item in pedido.line_items" v-bind:key="line_item.id" >
												<tr class="text-s " :class="[ pedido.line_items.indexOf(line_item) == pedido.line_items.length ? '' : 'border-t border-t-gray-300']"> 
													<!-- What is happening here -->
													<td class="py-3 px-6 whitespace-nowrap">
														{{line_item.producto.nombre}}
													</td>
													<td class="py-3 px-6">
														{{line_item.cantidad}}
													</td>													
													<td v-if="user !='admin' " class="py-3 px-6">
														${{line_item.precio}}
													</td>
													<td v-if="user !='admin' " class="py-3 px-6">
														${{line_item.precio * line_item.cantidad}}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>

								<div class="px-4 mt-2 space-y-2" v-if="hasAction(pedido)">									
									<div class=" " v-if="!orderActionsDisabled(pedido) && (user == 'admin' || pedido.proveedor.standalone) && !pedido.cancelado">
										<router-link :to="`/admin/orden/${pedido.id}/remision`">
											<button  class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4">
												Ver remisión
											</button>				
										</router-link>				
									</div>

									<div class="" v-if="canViewInvoices(pedido) && pedido.require_factura && pedido.pedido_factura.length > 0">
										<button  class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="openFacturas(pedido)">
											Ver facturas
										</button>								
									</div>

									<div class="" v-if="user == 'admin' && requiereSurtir(pedido)">
										<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="surtirPedido(pedido)">
											Surtir
										</button>
									</div>

									<div class="" v-if="user == 'admin' && canBeCancelled(pedido)">
										<button class="w-full bg-red hover:bg-red-dark rounded text-white font-bold py-2 px-4" @click="cancelarPedido(pedido)">
											Cancelar
										</button>
									</div>

									<div class="" v-if="(user == 'admin' || pedido.proveedor.standalone) && (pedido.envios.length > 0 || canCreateEnvio(pedido))">
										<div v-if="pedido.envios.length > 0" class="rounded bg-background-light">
											<table class="w-full text-sm text-left ">
												<thead class="text-s border-b border-b-gray-300 align-top">
													<th scope="col" class="py-3 px-6">
														Envio
													</th>
													<th scope="col" class="py-3 px-6">
														Tipo
													</th>												
													<th scope="col" class="py-3 px-6">
														Estatus 
													</th>
													<th scope="col" class="py-3 px-6">
														Evidencia 
													</th>
													<th scope="col" class="py-3 px-6 w-6">

													</th>
												</thead>
												<tbody v-for="envio in pedido.envios" v-bind:key="envio.id" class="">
													<tr class="text-s" :class="[ pedido.envios.indexOf(envio) == pedido.envios.length ? '' : 'border-t border-t-gray-300']">												
														<td class="py-2 px-6 whitespace-nowrap">
															{{envio.id}}
														</td>
														<td class="py-2 px-6">
															{{utils.upperCase(envio.type)}}
														</td>													
														<td class="py-2 px-6">														
															<div :class="[getStatusEnvio(envio).style]" class="rounded-full text-center py-1 px-2 mr-2">
																<p class="whitespace-nowrap">{{utils.upperCase(envio.status)}}</p>
															</div>
														</td>
														<td class="py-2 px-6">
															<div v-if=" envio.status != 'cancelado' " :class="[( (envio.evidencia && envio.evidencia.length > 0) ? 'border border-primary text-primary' : 'border border-yellow-500 text-yellow-500')]" class="rounded-full text-center py-1 px-2">
																<p class="whitespace-nowrap">{{ (envio.evidencia && envio.evidencia.length > 0) ? "Subido" : "Por subir"}}</p>
															</div>
														</td>
													<td v-if="canManageDelivery(pedido)" @click="editEnvio[envio.id] == null ? editEnvio[envio.id] = true : editEnvio[envio.id] = !editEnvio[envio.id]" class="cursor-pointer pr-2">
															<div v-if="!editEnvio[envio.id]">
																<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
																	<path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
																</svg>
															</div>
															<div class="h-6 w-6" v-if="editEnvio[envio.id]">
																<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
																	<path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
																</svg>
															</div>
														</td>													
													</tr>	
													<tr v-if="editEnvio[envio.id] && canManageDelivery(pedido)">
														<td colspan="99">
															<div class="px-2 pb-2 cursor-pointer">
																<div class="w-full text-center rounded bg-primary hover:bg-primary-dark text-white font-bold">
																	<label class="inline-block w-full py-2 px-4" :for="envio.id">Subir evidencia</label>
																	<input
																	class="hidden"
																	type="file"
																	:id="envio.id"
																	accept="*az"
																	@change="subirEvidencia(envio, $event)"
																	/>
																</div>
															</div>

															<div class="flex justify-between px-2 pb-2">														
																<select class="w-2/3 border border-gray-300 focus:border-gray-500 border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline whitespace-nowrap" v-if="editEnvio[envio.id]" v-model="envio.newStatus">
																	<option selected disabled :value="undefined">Escoger un estatus</option>
																	<option value="pendiente">Pendiente</option>			
																	<option value="exitoso">Exitoso</option>			
																	<option value="fallido">Fallido</option>			
															<option v-if="user == 'admin'" value="cancelado">Cancelado</option>
																</select>

																<div class="w-1/3 text-left pl-4 flex-none">
																	<button class="w-full rounded bg-primary hover:bg-primary-dark text-white font-bold p-2 px-4"  @click="updateEnvio(envio, {status: envio.newStatus});envio.newStatus = undefined">
																		Actualizar 
																	</button>
																</div>
															</div>

										<div v-if="user == 'admin' && isBillableDelivery(pedido, envio)" class="flex flex-row w-full px-2 pb-2">
																<div class="w-2/3 flex flex-row">
																	<input class="w-1/2 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="nombre" type="number" placeholder="0" min="0" v-model="envio.cargo_extra">
																	<select class="w-1/2 border border-gray-300 focus:border-gray-500 border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline whitespace-nowrap ml-4" v-if="editEnvio[envio.id]" v-model="envio.cargo_extra_type">
																		<option selected disabled :value="null">Escoger un tipo</option>
																		<option value="express">Express</option>			
																		<option value="materiales">Materiales</option>	
																		<option value="peso">Peso</option>	
																		<option value="peso_express">Peso y Express</option>
																		<!-- <option value="">Quitar</option>															 -->
																	</select>
																</div>
																<div class="w-1/3 pl-4">
																	<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="agregarCargoExtra(envio)">
																		Agregar cargo extra
																	</button>
																</div>
															</div>														
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div class="" v-if="canCreateEnvio(pedido)">
										<button class="w-full bg-primary hover:bg-primary-dark rounded text-white font-bold py-2 px-4" @click="crearEnvio(pedido)">
											Crear envío
										</button>
									</div>
								</div>
							</td>	
						</tr>					
					</tbody>
				</table>
			</div>		
		</div>	
	</div>
</template>

<script>
	import { ref } from "vue"
	import { useLoading } from 'vue-loading-overlay'
	import { utils } from '../utils/utils.js'
	import { useToast } from 'vue-toast-notification'
	import { createDelivery as createRutarioDelivery } from '../../services/rutario.js';
	import { canCancelAssignedOrder, canStartCollectionDelivery, canStartDelivery, getOrderDeliveryState, getCurrentOrderCollection, hasActiveCollection, hasReceivedCollection, hasSuccessfulDelivery, isBillableDelivery } from '../utils/recolecciones.js';
	import { getOrderPaymentStatus } from '../utils/payments.js';

	export default {
		props: ['ordenes', 'fields', 'user', 'selectionMode', 'selectedOrderIds', 'canSelectOrder', 'collectionReceived', 'disableActions', 'hideActions'],
		emits: ['toggle-order', 'order-cancelled'],

		setup(props, { emit }) {
			const showPedido = ref({})	
			const editEnvio = ref({})			

			const loading = useLoading({
				color: "#428b74",
				loader: "spinner"
			});

			function canSelect(pedido) {
				return !props.canSelectOrder || props.canSelectOrder(pedido)
			}

			function isSelected(pedido) {
				return Array.isArray(props.selectedOrderIds) && props.selectedOrderIds.includes(pedido.id)
			}

			function toggleSelection(pedido) {
				if (canSelect(pedido)) emit('toggle-order', pedido.id)
			}

			function isReadOnlyCollectionOrder(pedido) {
				if (pedido.proveedor?.standalone !== true || !hasActiveCollection(pedido)) return false
				if (props.user === 'proveedor') return true
				return props.user === 'admin' && !isCollectionReceived(pedido)
			}

			function isCollectionReceived(pedido) {
				return props.collectionReceived === true || hasReceivedCollection(pedido)
			}

			function canCreateEnvio(pedido) {
				if (
					props.hideActions === true ||
					props.disableActions === true ||
					pedido.require_entrega !== true ||
					pedido.cancelado === true
				) {
					return false
				}

				const canCreateAsAdmin = props.user === 'admin'
				const canCreateAsProvider =
					props.user === 'proveedor' &&
					pedido.proveedor?.standalone === true &&
					!hasActiveCollection(pedido)
				if (!canCreateAsAdmin && !canCreateAsProvider) return false

				if (pedido.proveedor?.standalone === true) {
					return props.user === 'admin'
						? canStartCollectionDelivery(pedido)
						: canStartDelivery(pedido)
				}

				if (isCollectionReceived(pedido)) {
					return ['not_started', 'failed'].includes(
						getOrderDeliveryState(pedido)
					)
				}

				return pedido.surtido === true && canStartDelivery(pedido)
			}

			function canManageDelivery(pedido) {
				if (props.user === 'admin') return true
				return props.user === 'proveedor' && pedido.proveedor?.standalone === true && !hasActiveCollection(pedido)
			}

			function orderActionsDisabled(pedido) {
				return props.hideActions === true || props.disableActions === true || isReadOnlyCollectionOrder(pedido)
			}

			function togglePedido(pedido) {
				showPedido.value[pedido.id] = !showPedido.value[pedido.id]
			}

			function getCollectionLink(pedido) {
				const collection = getCurrentOrderCollection(pedido)
				if (!collection) return ''

				return props.user === 'admin'
					? `/admin/recolecciones/${collection.id}`
					: `/proveedor/${pedido.proveedor.id}/recolecciones/${collection.id}`
			}

			function getLinks(pedido) {	
				switch (props.user) {	
				case "admin":	
					return {
						pedido: `/admin/orden/${pedido.id}`,
						cliente: `/admin/cliente/${pedido.cliente.id}`
					}									
				case "proveedor":
					return {
						pedido: `/proveedor/${pedido.proveedor.id}/orden/${pedido.id}`,
						cliente: `/proveedor/${pedido.proveedor.id}/cliente/${pedido.cliente.id}`
					}

				case "cliente":
					return {
						pedido: `/cliente/${pedido.cliente.id}/orden/${pedido.id}`,
						cliente: `/cliente/`
					}					
				}
			}

			// async function updatePedido(pedido, data) {
			// 	let key = Object.keys(data)[0]

			// 	let text;

			// 	switch (key) {	
			// 	}

			// 	if(confirm(text)){		
			// 		updatePedidoWithoutConfirm(pedido, data)					
			// 	}
			// }

			async function updateEnvio(envio, data) {
				let key = Object.keys(data)[0]

				let text;

				switch (key) {	
				case "status":	
					text = `¿Quieres marcar este envio cómo ${data[key]}?`
					break				
				}

				if(confirm(text)){		
					updateEnvioWithoutConfirm(envio, data)					
				}
			}

			async function updatePedidoWithoutConfirm(pedido, data) {
				let key = Object.keys(data)[0]				
				let loader = loading.show()			

				utils.updateManagedPedido(pedido, data, props.user)
				.then( () => {
					loader.hide()
					pedido[key] = data[key]
					if (key === 'cancelado' && data[key] === true) emit('order-cancelled', pedido.id)
					useToast().success('Orden actualizado', { position: "top-right", duration: 5000 });									
				})
				.catch( () => {
					loader.hide()
					console.log('Hubo un error, favor de intentarlo otra vez.')
				})
			}

			async function updateEnvioWithoutConfirm(envio, data) {
				let key = Object.keys(data)[0]
				let loader = loading.show()
				const providerId = props.user === 'proveedor'
					? props.ordenes.find((pedido) =>
						(pedido.envios || []).some(
							(candidate) => String(candidate.id) === String(envio.id)
						)
					)?.proveedor?.id
					: null

				return utils.updateEnvio(envio.id, data, providerId)
					.then( () => {
						loader.hide()
						envio[key] = data[key]
						useToast().success('Envio actualizado', { position: "top-right", duration: 5000 });
					})
					.catch( (error) => {
						loader.hide()
						console.log('Hubo un error, favor de intentarlo otra vez.')
						throw error
					})
			}

			async function crearEnvio(pedido) {
				if (confirm("¿Estas seguro que quieres crear una entrega?")) {
					const loader = loading.show()
					try {
						const collection = getCurrentOrderCollection(pedido)
						const recoleccionId =
							props.user === 'admin' &&
							pedido.proveedor?.standalone === true &&
							collection?.estado === 'recibida'
								? collection.id
								: null
						const envio = await utils.crearEnvio(
							pedido,
							recoleccionId,
							props.user === 'proveedor' ? pedido.proveedor.id : null
						)
						pedido.envios.push(envio)

						if (props.user === 'proveedor' || pedido.envio_type == "retiro") {
							useToast().success('Envio creado', { position: "top-right" });
							return
						}

						try {
							await createRutarioDelivery(envio, pedido)
							useToast().success('Envio creado en Rutario', { position: "top-right" });
						} catch (rutarioError) {
							console.error('Rutario error:', rutarioError)
							useToast().warning('Envio creado pero hubo un error al registrarlo en Rutario', { position: "top-right", duration: 7000 });
						}
					} catch (e) {
						console.log(e)
						alert('Hubo un error, favor de intentarlo otra vez.')
					} finally {
						loader.hide()
					}
				}
			}

			function surtirPedido(pedido) {
				if(confirm("¿Quieres surtir este pedido")){		
					let loader = loading.show()
					utils.updateInventory(pedido.line_items)		
					.then( () => {
						return updatePedidoWithoutConfirm(pedido, { surtido: true })					
					})
					.then( () => {		
						loader.hide()		
						pedido.surtido = true
						// useToast().success('Pedido surtido', { position: "top-right" });

					})
					.catch( error => {					
						loader.hide()
						throw error
					})
				}
			}															

			const subirEvidencia = async (envio, evt) => {
				let loader = loading.show()

				uploadFile(evt)
				.then( fileName => {
					return getURL(fileName)
				})
				.then( async (url) => {
					const evidencia = [...(envio.evidencia || []), url]
					await updateEnvioWithoutConfirm(envio, { evidencia })
					return evidencia
				})
				.then( (evidencia) => {
					loader.hide()
					envio.evidencia = evidencia
					useToast().success('Evidencia subida', { position: "top-right" });
				})
				.catch( error => {					
					loader.hide()
					throw error
				})
			}

			async function uploadFile(evt) {									
				if (!evt.target.files || evt.target.files.length === 0) {
					throw new Error("Selecciona un archivo")
				}
				const file = evt.target.files[0]
				const fileExt = file.name.split(".").pop()
				const fileName = `${Math.random()}.${fileExt}`
				const filePath = `${fileName}`					

				return await utils.uploadFile('remisiones', filePath, file)	
			}

			async function getURL(file) {
				let fileOnly = file.split('remisiones/')[1]
				return await utils.getURL('remisiones', fileOnly)				
			}

			function getStatus(pedido) {				
				if (pedido.cancelado == true ) {
					return {
						style: "border border-gray-300 text-gray-300",
						text: "Cancelado"
					}
				} else if (utils.isPendiente(props.user, pedido)) {
					return {
						style: "bg-yellow-500 text-white",
						text: "Pendiente"
					}
				} else {
					return {
						style: "bg-primary text-white",
						text: "Completo"
					}
				}
			}

			function getStatusEnvio(envio) {				
				if (envio.status == 'cancelado') {
					return {
						style: "border border-gray-300 text-gray-300",
						text: "Cancelado"
					}
				} else if (envio.status == "pendiente") {
					return {
						style: "bg-yellow-500 text-white",
						text: "Pendiente"
					}
				} else if (envio.status == "fallido") {
					return {
						style: "bg-red-500 text-white",
						text: "Fallido"
					}
				} else {
					return {
						style: "bg-primary text-white",
						text: "Exitoso"
					}
				}
			}

			function formatTime(pedido) {
				let date = new Date(pedido.created_at).toLocaleString('en-GB', { timeZone: 'America/Mexico_City' })
				return `${date.split(":")[0]}:${date.split(":")[1]}`
			}

			function requiereSurtir(pedido) {
				if (pedido.proveedor?.standalone) {
					return false
				}

				if (pedido.surtido) {
					return false
				}

				return utils.requireEntregaSurtir(pedido).surtir
			}

			function canBeCancelled(pedido) {
				if (pedido.cancelado) return false
				if (props.user !== 'admin') return false

				const collection = getCurrentOrderCollection(pedido)
				if (collection && ['solicitada', 'recibida'].includes(collection.estado)) {
					return canCancelAssignedOrder(pedido, 'admin')
				}

				if (orderActionsDisabled(pedido)) return false

				if (pedido.proveedor?.standalone) {
					return !hasSuccessfulDelivery(pedido)
				}

				return pedido.envios.filter(e => e.status == 'exitoso').length == 0
			}

			function cancelarPedido(pedido) {
				if (!canBeCancelled(pedido)) {
					useToast().warning('Esta orden pertenece a una recolección activa', { position: "top-right" });
					return
				}

				if(confirm("¿Quieres cancelar este pedido")){		
					let loader = loading.show()
					
					let data = { cancelado: true }
					
					updatePedidoWithoutConfirm(pedido, data)					
					.then( () => {
						if (pedido.surtido && !pedido.proveedor?.standalone) {
							console.log('Returning stock')
							let canceled_line_items = pedido.line_items.map( li => {
								let new_li =  Object.assign({}, li);
								new_li.cantidad = new_li.cantidad * -1
								return new_li
							})

							return utils.updateInventory(canceled_line_items)
						} else {
							return
						}
					})	
					.then( () => {		
						loader.hide()
						pedido.cancelado = true						
						useToast().success('Pedido cancelado', { position: "top-right" });

					})									
					.catch( error => {					
						loader.hide()
						throw error
					})
				}
			}

			function agregarCargoExtra(envio) {				
				if (envio.cargo_extra && !envio.cargo_extra_type) {
					return alert('Favor de agregar una descripción del cargo extra')
				}

				if(confirm("¿Quieres agregar un cargo extra a este pedido")){		
					let loader = loading.show()
					let data = { cargo_extra: envio.cargo_extra ? envio.cargo_extra : null, cargo_extra_type: envio.cargo_extra_type ? envio.cargo_extra_type : null }
					console.log(data)
					updateEnvioWithoutConfirm(envio, data)
					.then( () => {		
						loader.hide()						
						useToast().success('Envio actualizado', { position: "top-right" });

					})
					.catch( error => {					
						loader.hide()
						throw error
					})
				}
			}

			function openFacturas(pedido) {
				pedido.pedido_factura.forEach( pF => {
					window.open(pF.url)	
				})	    
			}

			function hasPendingEvidence(pedido) {
				if (pedido.require_entrega && (!pedido.envios || pedido.envios.length == 0)) {
					return true
				}

				if (pedido.require_entrega && pedido.envios.filter(e => e.status == 'pendiente').length > 0) {
					return true
				}

				// console.log(pedido.id, pedido.envios.filter(e => (e.status == 'exitoso' || e.status == 'fallido') && (!e.evidencia || e.evidencia.length == 0)).length > 0, pedido)
				return pedido.envios.filter(e => (e.status == 'exitoso' || e.status == 'fallido') && (!e.evidencia || e.evidencia.length == 0)).length > 0
			}

			function hasAction(pedido) {
				const hasCancellationAction =
					props.user == 'admin' &&
					canBeCancelled(pedido)

				if (props.hideActions === true) {
					return hasCancellationAction
				}

				const hasInvoiceAction = canViewInvoices(pedido) && pedido.require_factura && pedido.pedido_factura.length > 0
				if (orderActionsDisabled(pedido)) {
					const hasDeliveryDetails =
						props.user === 'proveedor' &&
						pedido.proveedor?.standalone === true &&
						pedido.envios.length > 0
					return hasInvoiceAction || hasCancellationAction || hasDeliveryDetails
				}

				if ((props.user == 'admin' || pedido.proveedor?.standalone) && !pedido.cancelado) {
					return true
				}

				if (hasInvoiceAction) {
					return true
				}	

				if (props.user == 'admin' && requiereSurtir(pedido)) {
					return true
				}

				if (canCreateEnvio(pedido)) {
					return true
				}

				if (hasCancellationAction) {
					return true
				}

				if ((props.user == 'admin' || pedido.proveedor?.standalone) && pedido.envios.length > 0) {
					return true
				}

				if (props.user == 'admin' && pedido.require_entrega && canStartDelivery(pedido)) {
					return true
				}

				return false				
			}	

			function canViewInvoices(pedido) {
				return props.user === 'admin' || (
					props.user === 'proveedor' && pedido.proveedor?.standalone === true
				)
			}

			return {      
				getStatus,
				getOrderPaymentStatus,
				showPedido,
				togglePedido,
				isReadOnlyCollectionOrder,
				isCollectionReceived,
				canCreateEnvio,
				canManageDelivery,
				canStartDelivery,
				orderActionsDisabled,
				editEnvio,
				requiereSurtir,
				surtirPedido,
				crearEnvio,
				subirEvidencia,
				formatTime,
				getLinks,
				props,
				openFacturas,
				utils,
				updateEnvio,
				agregarCargoExtra,
				getStatusEnvio,
				hasPendingEvidence,
				canBeCancelled,
				cancelarPedido,
				hasAction,
				canViewInvoices,
				getCurrentOrderCollection,
				hasActiveCollection,
				canSelect,
				isSelected,
				toggleSelection,
				getCollectionLink,
				isBillableDelivery
			}
		}
	}
</script>
